import * as React from 'react';
import { matchPath, withRouter } from 'react-router';

import { inject, observer } from 'mobx-react';

import { EStore } from '@enums';

import { getPageTitle, translations } from '@utils';

import { ITranslatable, Translate, TranslateFn } from '@decorators';

import { getState } from '@stores';

import { IPageTitleProps } from './types';

interface IPageTitleState {
	title: ITitle;
}

interface ITitle {
	seo: string;
	visual: string;
}

@inject(EStore.UI)
@observer
@Translate('base.components.PageTitle')
export class TitleComponent extends React.PureComponent<IPageTitleProps, IPageTitleState> implements ITranslatable {

	declare t: TranslateFn;

	constructor(props: IPageTitleProps) {
		super(props);
		const title = this.getTitle(props.location.pathname);
		this.state = {
			title: title,
		};
		this.setTitle(title);
	}

	componentDidUpdate({ location: prevLocation, uiStore }: Readonly<IPageTitleProps>, prevState: Readonly<{}>) {
		if (
			uiStore.pageTitle.value !== this.state.title.visual ||
			(prevLocation.pathname !== this.props.location.pathname)
		) {
			this.updateTitle();
		}
	}

	getTitle(pathname?: string) {
		return getPageTitle(
			pathname,
			(url: string) => Boolean(matchPath(pathname, url)),
			{ state: getState() },
		);
	}

	setTitle(title: ITitle) {
		if (!IS_SSR) {
			document.title = title.seo || translations.common('my-seo');
		}
		this.props.uiStore.pageTitle.setTitle(title.visual);
	}

	updateTitle(pathname?: string) {
		const pageTitle = this.getTitle(pathname || this.props.location.pathname);
		this.setState({
			title: pageTitle,
		});
		pageTitle && this.setTitle(pageTitle);
	}

	render(): JSX.Element {
		// уловка, чтобы заставить рендерить MOBX без вывода observable на экран
		if (this.props.uiStore.pageTitle.value) {
			return null;
		}
		return null;
	}

}

export const PageTitle = withRouter(TitleComponent);
